import { ReactNode } from 'react'

export interface CardProps {
  className?: string
  children: ReactNode | ReactNode[]
  size?: 'small' | 'medium' | 'large'
  corner?: 'rounded' | 'square'
}

export const Card = ({
  className = '',
  children,
  size = 'large',
  corner = 'rounded'
}: CardProps) => {
  const buildCardSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'p-4'
      case 'medium':
        return 'p-7'
      case 'large':
        return 'p-5 md:p-10'
      default:
        return ''
    }
  }

  const buildCardCornerClasses = () => {
    switch (corner) {
      case 'square':
        return ''
      case 'rounded':
        return 'rounded-[10px] '
      default:
        return ''
    }
  }

  return (
    <div
      className={`bg-white text-ivoryBlack transition-shadow duration-300 ease-in-out overflow-hidden mb-1 ${buildCardCornerClasses()} ${buildCardSizeClasses()} ${className}`}
    >
      {children}
    </div>
  )
}
